<template>
  <v-card>
    <v-toolbar
      dense
      card
      class="elevation-2"
      @click.stop="showConstant = !showConstant"
    >
      <v-toolbar-title class="body-2 beez-bold ">
        {{ title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <transition name="fade" mode="out-in" v-if="!designer && showConstant">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator" @click.stop="edit">
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit constants</span>
        </v-tooltip>
      </transition>
      <transition name="fade" mode="out-in" v-if="!designer">
        <v-btn flat icon @click.stop="showConstant = !showConstant">
          <v-icon>
            {{ showConstant ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </v-btn>
      </transition>
      <transition name="fade" mode="out-in" v-if="designer">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator" @click.stop="save">
            <v-icon>save</v-icon>
          </v-btn>
          <span>Save constants</span>
        </v-tooltip>
      </transition>
      <transition name="fade" mode="out-in" v-if="designer">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator" @click.stop="cancel">
            <v-icon>close</v-icon>
          </v-btn>
          <span>cancel</span>
        </v-tooltip>
      </transition>
    </v-toolbar>
    <transition name="bounce" mode="out-in">
      <v-card-text v-if="showConstant">
        <div v-if="!designer">
          <template v-if="constants.length > 0">
            <v-jsoneditor
              key="display"
              v-model="constants"
              :options="{ mode: 'view' }"
              height="400px"
              :plus="true"
              style="background: #fff"
            >
            </v-jsoneditor>
          </template>
          <template v-else>
            No Constants found
          </template>
        </div>
        <div v-else-if="designer">
          <v-jsoneditor
            key="change"
            v-model="constants"
            :options="jsonOptions"
            height="400px"
            :plus="true"
          >
          </v-jsoneditor>
        </div>
      </v-card-text>
    </transition>
  </v-card>
</template>

<script>
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  components: { VJsoneditor },
  name: 'InputConstant',
  props: {
    title: {
      type: String,
      default: 'Constants'
    },
    inputConstant: Array
  },
  data: function() {
    return {
      showConstant: false,
      jsonOptions: { mode: 'code' },
      designer: false,
      constants: []
    }
  },
  created() {
    this.setConstant()
  },
  methods: {
    setConstant() {
      if (
        typeof this.inputConstant !== 'undefined' &&
        this.inputConstant &&
        this.inputConstant.length > 0
      ) {
        this.constants = this.inputConstant
      } else {
        this.constants = []
      }
    },
    edit() {
      this.designer = true
    },
    save() {
      this.designer = false
      this.$emit('save', this.constants)
    },
    cancel() {
      this.setConstant()
      this.designer = false
    }
  }
}
</script>

<style scoped></style>
